import { useState } from 'react';

type FormResponse = {
  code?: string;
  message?: string;
  meta?: { message?: string; detail?: string };
};

const HONEYPOT_NAMES = ['company_alt', 'website_alt'];

export function useFormSubmit(url: string, successMessage: string) {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const submit = async (form: HTMLFormElement) => {
    const formData = new FormData(form);
    const honeypot = HONEYPOT_NAMES
      .map((name) => String(formData.get(name) || ''))
      .join('')
      .trim();

    if (honeypot) {
      setStatus('success');
      setMessage(successMessage);
      form.reset();
      return;
    }

    setStatus('submitting');
    setMessage('');

    try {
      const body = new URLSearchParams();
      formData.forEach((value, key) => {
        if (HONEYPOT_NAMES.includes(key)) return;
        const text = String(value);
        if (text.trim()) body.append(key, text);
      });

      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      const responseText = await response.text();
      let parsed: FormResponse | null = null;
      try {
        parsed = JSON.parse(responseText) as FormResponse;
      } catch {
        parsed = null;
      }

      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const failedText = typeof serverMsg === 'string' ? serverMsg.toLowerCase() : '';
      const isSpam = failedText.includes('spam');

      if (response.ok && parsed?.code === 'OK' && !isSpam) {
        setStatus('success');
        setMessage(successMessage);
        form.reset();
      } else {
        setStatus('error');
        setMessage(isSpam ? '提交未通过校验，请稍后重试。' : serverMsg || '提交失败，请稍后重试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络异常，请检查网络后重试。');
    }
  };

  return { status, message, submit };
}